import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import './Hero.css';

const HeroSearch = (props) => {
  console.log(props, 'hero search')
    const handleSubmit = (e) => {
      props.searchHandler(props.searchCriteria);
    }
    return (
            <form className="hero-form" onSubmit={handleSubmit}>
              <input
                  onChange={props.handleChange}
                  className="landing-input"
                  type="text"
                  name="searchCriteria"
                  value={props.searchCriteria}
                  placeholder={props.randomTitle}
                  id="hero-input"
              />
              <div id="hero-button" onClick={() => props.searchHandler(props.searchCriteria)}>
                <Link to={`/search/?q=${props.searchCriteria}`}>
                  <button className="button">
                    <FontAwesomeIcon icon={faSearch} />
                  </button>
                </Link>
              </div>
          </form>
    );
};

export default HeroSearch;